import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@hooks/useStore';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { detectMobile } from '@utils/detectMobile';
import VerificationCodeForm from '@forms/VerificationCodeForm';
import LoginForm from '@forms/LoginForm';
import { FinishRegistrationForm } from '@forms/FinishRegistrationForm';
import LogoIcon from '@icons/logo_icon.svg?component';
import BGIcon from '@icons/auth/login_bg_icon.svg?component';
import { AuthTransFields } from './types';
import { authTranslations } from './translations';

const Auth: FC = () => {
  const {
    authStore: { authStep },
  } = useStore();

  const isMob = detectMobile();

  const { t } = useMyTranslations<AuthTransFields>([authTranslations.name]);

  return (
    <div className="relative h-screen py-8 px-60">
      <div
        className={`absolute flex items-center gap-x-4 top-8 z-10 ${
          isMob && '!top-1/4 left-1/2 transform -translate-y-1/2 -translate-x-1/2'
        }`}
      >
        <LogoIcon width={isMob ? 64 : 54} height={isMob ? 64 : 54} />
        <h1 className="extra-large-text text-[#385BBC]">GeoBuyer</h1>
      </div>
      <div className="absolute left-0 top-0 h-1/2 w-full bg-[#F6F8FF] z-0" />
      {!isMob && (
        <BGIcon
          className="absolute z-0 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
          width={556}
          height={596.23}
        />
      )}
      <div
        className={`absolute z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[376px] px-[32px] pt-[24px] pb-[32px] self-center bg-white rounded-[20px] ${
          isMob && '!top-3/4 px-[20px] w-full'
        }`}
      >
        {/* {!isMob && (
          <p className="uppercase default-text mb-[24px]">
            {t(authStep === 'finish' ? 'Complete Registration' : 'authorization')}
          </p>
        )} */}
        <p className="uppercase default-text mb-[24px]">
          {t(authStep === 'finish' ? 'Complete Registration' : 'authorization')}
        </p>
        {authStep === 'creds' && <LoginForm />}
        {authStep === 'code' && <VerificationCodeForm />}
        {authStep === 'finish' && <FinishRegistrationForm />}
      </div>
    </div>
  );
};

export default observer(Auth);
